<div class="confirmation-summary">
  <section
    *ngFor="let section of stepSummaries"
    class="confirmation-section">
    <header class="confirmation-section__header">
      <h3 class="confirmation-section__title">{{ section.title }}</h3>
      <div class="confirmation-section__meta-group">
        <span
          *ngFor="let meta of section.meta"
          class="confirmation-section__meta">
          {{ meta.label }}: {{ meta.value }}
        </span>
      </div>
      <button
        type="button"
        class="confirmation-section__edit"
        [attr.aria-label]="'Editar ' + section.title"
        (click)="editStep(section.stepIndex)">
        <b3-icon name="edit_square" size="sm"></b3-icon>
      </button>
    </header>
    <span class="confirmation-section__divider" aria-hidden="true"></span>

    <div class="confirmation-section__body">
      <p class="confirmation-section__highlight">{{ section.highlight }}</p>

      <div class="confirmation-grid">
        <div
          *ngFor="let row of section.rows"
          class="confirmation-grid__row">
          <div
            *ngFor="let field of row"
            class="confirmation-field">
            <span class="confirmation-field__label">{{ field.label }}</span>
            <span class="confirmation-field__value">{{ field.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="confirmation-section">
    <header class="confirmation-section__header">
      <h3 class="confirmation-section__title">Etapa 4 - Co-benefícios</h3>
      <div class="confirmation-section__meta-group"></div>
      <button
        type="button"
        class="confirmation-section__edit"
        aria-label="Editar co-benefícios"
        (click)="editStep(3)">
        <b3-icon name="edit_square" size="sm"></b3-icon>
      </button>
    </header>
    <span class="confirmation-section__divider" aria-hidden="true"></span>

    <div class="confirmation-section__body">
      <p class="confirmation-section__highlight">{{ odsCountLabel }}</p>

      <div class="confirmation-ods-list" *ngIf="selectedOds.length > 0">
        <div *ngFor="let ods of selectedOds" class="confirmation-ods-item">
          <span class="confirmation-field__label">ODS {{ ods.id }}</span>
          <span class="confirmation-field__value">{{ ods.label }}</span>
        </div>
      </div>

      <div class="confirmation-grid">
        <div class="confirmation-grid__row">
          <div class="confirmation-field confirmation-field--full">
            <span class="confirmation-field__label">Outros co-benefícios</span>
            <span class="confirmation-field__value">{{ coBenefitsSummary }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
